import { useQuery, useQueryClient } from '@tanstack/react-query';

import { queries } from '../api/queryKeys/queries';

const findApplicableTypes = ({ enumValues, context }) => {
    if (!Object.values(enumValues).every((it) => it.applicableTypes)) {
        return enumValues;
    }

    const filteredValues = Object.entries(enumValues).filter(([, value]) => value.applicableTypes?.includes(context));
    return Object.fromEntries(filteredValues);
};

export const useEnums = () => {
    const queryClient = useQueryClient();
    const { data, isPending, isSuccess } = useQuery({
        ...queries.enums.list,
        staleTime: Infinity,
    });

    const getHumanReadableValue = (enumType, enumKey) => {
        if (!data) {
            return null;
        }

        const value = data[enumType][enumKey];

        return value ? value.humanReadableValue : null;
    };

    const getEnumsForTypeAndContext = (enumType, context) => {
        if (!data) {
            return null;
        }

        if (!context) {
            return data[enumType];
        }

        return findApplicableTypes({
            enumValues: data[enumType],
            context,
        });
    };

    const getEnumField = (enumType, enumKey, field) => {
        return data[enumType][enumKey]?.[field];
    };

    const prefetch = () => {
        queryClient.prefetchQuery({ ...queries.enums.list, staleTime: Infinity });
    };

    return {
        enums: isSuccess ? data : {},
        isPending,
        getHumanReadableValue,
        prefetch,
        getEnumsForTypeAndContext,
        getEnumField,
    };
};
